{
	"adaptiveCropAria": "Toggle Adaptive Crop From References",
	"adaptiveCropping": "Adaptive Cropping",
	"adaptiveCroppingDescription": "Automatically match cropping from Reference Photos to similar photos.",
	"adaptiveEditing": "Adaptive Editing",
	"adaptiveHealing": "Adaptive Healing",
	"adaptiveHealingAria": "Toggle Adaptive Healing From References",
	"adaptiveHealingDescription": "Automatically match healing adjustments from Reference Photos to similar photos.",
	"adaptiveMasking": "Adaptive Masking",
	"adaptiveMaskingAria": "Toggle Adaptive Masking From References",
	"adaptiveMaskingDescription": "Automatically match masks from Reference Photos to similar photos.",
	"adaptivePerspectiveAria": "Toggle Adaptive Perspective From References",
	"adaptivePerspectiveCorrection": "Adaptive Perspective Correction",
	"adaptivePerspectiveDescription": "Automatically match perspective corrections from Reference Photos to similar photos.",
	"adaptiveStraightenAria": "Toggle Adaptive Straighten From References",
	"adaptiveStraightening": "Adaptive Straightening",
	"adaptiveStraighteningDescription": "Automatically match straightening from Reference Photos to similar photos.",
	"adjustFaceDetectorConfidenceThreshold": "Adjust Face Detector Confidence Threshold",
	"adjustFaceParserConfidenceThreshold": "Adjust Face Parser Confidence Threshold",
	"adjustRfdetrPersonConfidenceThreshold": "Adjust RF-DETR Person Confidence Threshold",
	"aiDebugAria": "Toggle AI Debug Mode",
	"aiDebugDescription": "Display AI Debug information in the app for troubleshooting purposes",
	"aiDebugMode": "AI Debug Mode",
	"aiGenerateErase": "AI Generate & Erase",
	"aiGenerateEraseDescription": "Enable AI Generate & Erase tools",
	"aiProcessing": "AI Processing",
	"appTheme": "App Theme",
	"appThemeAria": "App theme",
	"appThemeDescription": "Choose Light, Dark, or follow your browser theme.",
	"autoAdjustments": "Auto Adjustments",
	"autoAdjustmentsAria": "Auto Adjustments",
	"autoLightingDescription": "Automatically adjust lighting and white balance when applying a preset or opening an unedited photo.",
	"autoLightingWhiteBalance": "Auto Lighting & White Balance",
	"autoPerspectiveAria": "Auto Perspective",
	"autoPerspectiveCorrection": "Auto Perspective Correction",
	"autoPerspectiveDescription": "Automatically correct perspective during processing.",
	"autoStraighten": "Auto Straighten",
	"autoStraightenDescription": "Automatically straighten photos during processing.",
	"colorMatch": "Color Match",
	"colorMatchDebugAria": "Toggle Color Match Debug",
	"colorMatchDescription": "Enable Color Match debug features",
	"dark": "Dark",
	"debug": "Debug",
	"editorBackground": "Editor Background",
	"editorBackgroundDescription": "Choose the background color in Focus view.",
	"editorPreferences": "Editor Preferences",
	"enableTheExperimentalPeopleAnd": "Enable the experimental people and person-component masking workflow.",
	"enableTheExperimentalPeopleRetouching": "Enable the experimental people retouching panel and people masks.",
	"experiment": "{{title}} Experiment",
	"experiments": "Experiments",
	"faceDetectorConfidenceThreshold": "Face Detector Confidence Threshold",
	"faceParserPixelConfidenceThreshold": "Face Parser Pixel Confidence Threshold",
	"featureFlags": "Feature flags",
	"forwardOnlyReprocessing": "Forward-only Reprocessing",
	"forwardProcessingAria": "Toggle Forward Only Reprocessing",
	"forwardProcessingDescription": "When new Reference Photos are marked, only reprocess the current and subsequent scenes.",
	"generativeFillAria": "Toggle Generative Fill",
	"healingDebugDownloads": "Healing Debug Downloads",
	"healingDebugDownloadsAria": "Toggle Healing Debug Downloads",
	"healingDebugDownloadsDescription": "Download healing AI input and mask debug images",
	"internalStylesAria": "Toggle Show Internal AI Styles",
	"light": "Light",
	"localization": "Localization",
	"localizationDescription": "Choose an app language or use your account language.",
	"minimumRetinafaceConfidenceForFace": "Minimum RetinaFace confidence for face detections used by AI features.",
	"minimumSigmoidPersonclassConfidenceFor": "Minimum sigmoid person-class confidence for RF-DETR person detections.",
	"minimumSoftmaxConfidenceForKeeping": "Minimum softmax confidence for keeping parsed face-part pixels. Zero keeps the argmax mask unchanged.",
	"peopleMasking": "People Masking",
	"performanceDebugAria": "Toggle Performance Debug",
	"performanceMetrics": "Performance Metrics",
	"performanceMetricsDescription": "Display Performance Metrics in the app for troubleshooting purposes",
	"pixiesetEarlyAccess": "Pixieset Early Access",
	"pixiesetEarlyAccessAria": "Toggle Pixieset Early Access",
	"pixiesetEarlyAccessDescription": "Enable Pixieset early access features. If a URL parameter (?pixiesetauth=1) is present, it will take precedence.",
	"preferredLocale": "Use account language",
	"retouching": "Retouching",
	"rfdetrPersonConfidenceThreshold": "RF-DETR Person Confidence Threshold",
	"sceneDistanceThreshold": "Scene Distance Threshold Delta",
	"sceneThresholdAria": "Adjust Scene Similarity Threshold",
	"sceneThresholdDescription": "Adjust clustering by scene similarity. Positive = more photos in the same cluster, negative = less.",
	"showInternalStyles": "Show Internal Styles",
	"showInternalStylesDescription": "Display internal styles in AI Styles panel with an Internal tab.",
	"showMasksCreatedInternallyBy": "Show masks created internally by retouching in the Masks panel for debugging.",
	"showRetouchingMasks": "Show Retouching Masks",
	"system": "System",
	"timeThresholdAria": "Adjust Time Grouping Threshold",
	"timeThresholdDescription": "Adjust clustering time window. Positive = larger window, negative = smaller.",
	"timeWindowDelta": "Time Window Delta (seconds)",
	"togglePeopleMasking": "Toggle People Masking",
	"toggleRetouching": "Toggle Retouching",
	"toggleRetouchingMasksDebug": "Toggle Retouching Masks Debug",
	"viewReferences": "View References",
	"viewReferencesDebugAria": "Toggle View References Debug",
	"viewReferencesDescription": "Allows viewing the Reference Image used by the current project or AI Style."
}
